var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCollapse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.612,
    height: 15.238,
    viewBox: "0 0 15.612 15.238",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_288",
    "data-name": "\\uADF8\\uB8F9 288",
    transform: "translate(260.306 -343.762) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow_separator_icon",
    "data-name": "arrow separator icon",
    transform: "translate(-381.917 536.68) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-back",
    "data-name": "Icon ionic-ios-arrow-back",
    d: "M13.877,13.811,19.642,8.05A1.089,1.089,0,1,0,18.1,6.512l-6.532,6.528a1.087,1.087,0,0,0-.032,1.5L18.1,21.114a1.089,1.089,0,1,0,1.542-1.538Z",
    transform: "translate(265.123 719.485)",
    fill: "#465372"
  })), /*#__PURE__*/React.createElement("g", {
    id: "arrow_separator_icon-2",
    "data-name": "arrow separator icon",
    transform: "translate(-381.917 529.779) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-back-2",
    "data-name": "Icon ionic-ios-arrow-back",
    d: "M13.877,13.811,19.642,8.05A1.089,1.089,0,1,0,18.1,6.512l-6.532,6.528a1.087,1.087,0,0,0-.032,1.5L18.1,21.114a1.089,1.089,0,1,0,1.542-1.538Z",
    transform: "translate(265.123 719.485)",
    fill: "#465372"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapse);
export default __webpack_public_path__ + "static/media/collapse.af606ff838752521902f7273b63472d3.svg";
export { ForwardRef as ReactComponent };